const rankingItems = [
  { rank: 1, title: '动作猛片 · 硬汉专属合集', source: '香蕉视频', heat: '今日播放 128.6 万', tag: '热', tagColor: 'bg-red-500' },
  { rank: 2, title: '悬疑剧场 · 烧脑推理全系列', source: '红桃视频', heat: '今日播放 96.3 万', tag: '新', tagColor: 'bg-accent-500' },
  { rank: 3, title: '午夜专场 · 限时开放频道', source: '蜜桃视频', heat: '今日播放 87.9 万', tag: '火', tagColor: 'bg-orange-500' },
  { rank: 4, title: '综艺爆笑 · 最新季全收录', source: '樱花视频', heat: '今日播放 73.2 万', tag: '荐', tagColor: 'bg-primary-500' },
  { rank: 5, title: '动漫番剧 · 周更追番指南', source: '香蕉视频', heat: '今日播放 58.4 万', tag: '追', tagColor: 'bg-accent-500' },
  { rank: 6, title: '经典港片 · 高清修复重映', source: '红桃视频', heat: '今日播放 45.1 万', tag: '精', tagColor: 'bg-amber-600' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="section-title">热门榜单</h2>
        <p className="section-subtitle">实时热度排行，看看大家都在看什么</p>
        <div className="mt-10 max-w-3xl mx-auto space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-50 border border-background-200/70 rounded-xl p-4 hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg bg-background-100 flex items-center justify-center flex-shrink-0">
                <span
                  className={`text-sm md:text-base font-bold ${
                    item.rank <= 3 ? 'text-primary-600' : 'text-foreground-500'
                  }`}
                >
                  {item.rank}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                    {item.title}
                  </span>
                  <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium text-white whitespace-nowrap ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
                <div className="flex items-center gap-3 mt-1 flex-wrap">
                  <span className="text-xs text-foreground-500 flex items-center gap-1">
                    <i className="ri-vidicon-line"></i>
                    {item.source}
                  </span>
                  <span className="text-xs text-foreground-500">{item.heat}</span>
                </div>
              </div>
              <div className="flex-shrink-0">
                <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors text-lg"></i>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-8">
          <a
            href="#carousel"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看更多热门专题
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}